import React, {Component} from 'react';
import '../../Home.css';
import {ICON, NAME, TAGLINE, NextTrainBostonNav, StoreBadges} from './links';

let _this;

class NextTrainBostonProduct extends Component {

    constructor(props, context) {
        super(props);
        _this = this;
    }

    render() {
        return <div className="container">
            <div align="center">
                <NextTrainBostonNav navigate={_this.props.navigate} selected="NextTrainBostonProduct"/>
            </div>
            <div className="card" id="shell4">
                <div id="card_content">
                    <div>
                        <img style={{borderRadius: '10%', margin: '0 16px 0 16px'}}
                             className="roundrect"
                             src={ICON}
                             align="left"
                             alt="app icon"
                             width="128"/>
                        <div>
                            <h2>{NAME}</h2>
                            <h3>{TAGLINE}</h3>
                        </div>
                    </div>
                    <br/>
                    <br/>
                    <p>
                        <b>Why you need Next Train Boston?</b><br/><br/>
                        Next Train Boston shows the next MBTA commuter rail trains and ferries from your station, in
                        one tap and without a connection. Pick your line once: its stations are listed in order, from
                        South Station or North Station outward. Open a station and you see every departure with its
                        time, direction and final stop; tap a train to see every stop on its way.
                    </p>
                    <p>
                        <b>Set your commute and stop looking things up.</b><br/><br/>
                        Tell the app your home station, your work station and when you head back. In the morning it
                        opens on the trains to work, in the evening on the trains home. The Home Screen widget does the
                        same, so a glance tells you whether to hurry.
                    </p>
                    <p>
                        <b>Ferries too.</b> Charlestown, Hingham, Hull, East Boston, Lynn, Winthrop and Quincy ferries
                        are lines in the app, with their piers as stations.
                    </p>
                    <p>
                        <b>Always up to date.</b> The full timetable lives inside the app, and the app refreshes it by
                        itself when the MBTA changes its schedules. Also on Apple Watch.
                    </p>
                    <div className="row">
                        <div className="column">
                            <img src="/ntb_ss1.png" alt="widget in the morning and in the evening" width="100%"/>
                        </div>
                        <div className="column">
                            <img src="/ntb_ss2.png" alt="stations of your line with your commute on top" width="100%"/>
                        </div>
                        <div className="column">
                            <img src="/ntb_ss3.png" alt="departure board" width="100%"/>
                        </div>
                        <div className="column">
                            <img src="/ntb_ss4.png" alt="all commuter rail lines" width="100%"/>
                        </div>
                    </div>
                </div>
                <br/>
                <br/>
                <br/>
                <br/>
                <br/>
                <div className="divider"></div>
                <div style={{margin: '0 24px 0 24px'}}>
                    <b>Data Sources & Notice</b>
                    <p>Schedules come from the MBTA's public GTFS feed under the MassDOT developer license.
                        Next Train Boston is made by AnswerSolutions LLC and is not affiliated with or endorsed by the
                        MBTA or MassDOT. For service alerts and track assignments, check mbta.com.</p>
                </div>
                <div className="divider"></div>
                <br/>
                <div style={{margin: '0 24px 0 24px'}}>
                    <h4>WORKS ON IPHONE, APPLE WATCH AND ANDROID (COMING SOON)</h4>
                </div>
                <br/>
                <div align="center" hspace="10" vspace="10">
                    <StoreBadges/>
                </div>
            </div>
            <div align="center">
                <NextTrainBostonNav navigate={_this.props.navigate} selected="NextTrainBostonProduct"/>
            </div>
        </div>
    }
}

export default NextTrainBostonProduct;
